// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_1QpxM","sessionRight":"cwwR-","main":"XxcPt","side":"kUHFE","msg":"_Lvrv","right":"pb_g1","content":"_9ZkAY","cover":"_3pFs4","click":"_3YDr-"};